export default "__VITE_ASSET__D45uoDah__"